import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import { clientStore } from 'apps/client/app';
import { conf } from 'apps/signIn/config.yaml';

import Button from 'components/Button';
import Tooltip from 'components/Tooltip';

import {
  MainWrapperSocialButtons,
  WrapperSocialButton,
} from 'apps/signIn/styles';

@withNamespaces()
@observer
export class SocialButtons extends React.Component {
  render() {
    const { t } = this.props;
    // const nextParam = clientStore.routerStore.params.get('next');
    const nextParam = clientStore.next();
    const nextPath = nextParam ? `?next=${nextParam}` : '';

    const keysList = Object.keys(conf.social);
    const buttons = keysList.map(key => {
      const item = conf.social[key];

      let HMACParam = '';
      if (!clientStore.signedInProfile && clientStore.HMAC) {
        let appendSymbol = '?';
        if (nextPath) appendSymbol = '&';
        HMACParam = `${appendSymbol}hmac=${clientStore.HMAC}`;
      }
      const href = `${MAIN_URL}${item.link}${nextPath}${HMACParam}`;

      return (
        <WrapperSocialButton key={item.icon}>
          <Button
            as='a'
            text={key === 'google' ? item.title : ''}
            outline
            variant='minimal'
            icon={item.icon}
            href={href}
            data-for='signInTip'
            data-tip={t(item.title)}
            customColor='black'
          />
        </WrapperSocialButton>
      );
    });

    return (
      <>
        <Tooltip id='signInTip' delayShow={500} />
        <MainWrapperSocialButtons>{buttons}</MainWrapperSocialButtons>
      </>
    );
  }
}

SocialButtons.propTypes = {
  t: PropTypes.func,
};
